import React from 'react';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { Link, useNavigate } from 'react-router-dom';
import CollapsibleComponent from '../../common/CollapsibleComponent/CollapsibleComponent';
import { getFaqData } from './FaqData';
import { PageAbsolutePath } from '../../../consts/Common';
import Links from '../../common/Widgets/Links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const FaqsPage = (): JSX.Element => {
  const navigate = useNavigate();
  const faqData = getFaqData();

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  const goBack = (): void => {
    navigate(-1);
  };

  return (
    <>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <CollapsibleComponent contents={faqData} />
      <p>
        All cover is subject to the terms and conditions provided with the
        policy, the
        <Link
          id='lnkPolicyDocumentInText'
          className='in-text'
          to={PageAbsolutePath.Insurance.PolicyDocuments}>
          Policy Document
        </Link>
        and the
        <Link
          id='lnkTermsOfBusiness'
          className='in-text'
          to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
          Terms of Business.
        </Link>
      </p>
      <div className='flex-row'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </>
  );
};

export default FaqsPage;
